import { InputProps } from 'antd';

interface Props extends InputProps {
  type?: 'error' | 'help';
  isHover?: boolean;
}

export default function InfoCircleIcon(props: Props) {
  const { type = 'error', isHover = false } = props;
  const color = type === 'error' ? '#FF0000' : isHover ? '#FFC74E' : '#4F4F4F';
  return type === 'error' ? (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 19.1668C4.93729 19.1668 0.833374 15.0629 0.833374 10.0002C0.833374 4.93741 4.93729 0.833496 10 0.833496C15.0628 0.833496 19.1667 4.93741 19.1667 10.0002C19.1612 15.0602 15.06 19.1613 10 19.1668ZM9.08337 12.7502V14.5835H10.9167V12.7502H9.08337ZM9.08337 5.41683V10.9168H10.9167V5.41683H9.08337Z"
        fill={color}
      />
    </svg>
  ) : (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.165 2C6.10325 2 2 6.10325 2 11.165C2.00006 12.3686 2.23718 13.5603 2.69783 14.6723C3.15847 15.7842 3.83361 16.7945 4.6847 17.6455C5.5358 18.4965 6.54617 19.1715 7.65815 19.6321C8.77012 20.0926 9.96191 20.3296 11.1655 20.3295C12.369 20.3295 13.5608 20.0923 14.6727 19.6317C15.7847 19.1711 16.795 18.4959 17.646 17.6448C18.497 16.7937 19.172 15.7833 19.6325 14.6714C20.0931 13.5594 20.3301 12.3676 20.33 11.164C20.33 6.10325 16.2258 2 11.165 2ZM11.0208 16.5103H10.9722C10.2256 16.4883 9.6986 15.9375 9.72056 15.2014C9.74156 14.4778 10.281 13.9517 11.0027 13.9517L11.0466 13.9536C11.8142 13.9756 12.3354 14.5207 12.3135 15.2778C12.2915 16.0034 11.7617 16.5103 11.0208 16.5103ZM14.1627 10.2752C13.9871 10.5234 13.6014 10.8347 13.1145 11.2137L12.5779 11.5832C12.2839 11.8123 12.1063 12.029 12.0404 12.24C11.987 12.4061 11.9622 12.451 11.9574 12.7899V12.8758H9.90959L9.91531 12.702C9.94109 11.9918 9.95828 11.5717 10.2533 11.2251C10.7163 10.6829 11.7378 10.0241 11.7808 9.99646C11.9209 9.89408 12.0432 9.76924 12.1426 9.627C12.3574 9.33009 12.4519 9.09715 12.4519 8.86993C12.4519 8.55107 12.3584 8.25607 12.1722 7.99544C11.9927 7.74149 11.6519 7.61547 11.1593 7.61547C10.6705 7.61547 10.3354 7.77013 10.1358 8.089C9.92963 8.41455 9.82557 8.75728 9.82557 9.10765V9.19548H7.71476L7.71858 9.10383C7.77299 7.81214 8.23506 6.88132 9.08855 6.3381C9.62604 5.99346 10.2953 5.81875 11.0753 5.81875C12.0949 5.81875 12.9579 6.06697 13.6357 6.55577C14.3241 7.05125 14.6725 7.794 14.6725 8.76205C14.6716 9.30336 14.5007 9.81221 14.1627 10.2752Z"
        fill={color}
      />
    </svg>
  );
}
